import { useEffect } from 'react';
import clarity from '@microsoft/clarity';

const CLARITY_PROJECT_ID = import.meta.env.VITE_JSV4_CLARITY_PROJECT_ID;


export const useClarity = ({ userProfile }={}) => {
    useEffect(() => {
        if (!clarity?.init || !CLARITY_PROJECT_ID) return;

        try {
            clarity.init(CLARITY_PROJECT_ID);

            clarity.setTag("page_type", "Careers");

            if (!userProfile?.email) {
                clarity.setTag("visitor_type", "Anonymous");
            }
        } catch {}
    }, []);

    useEffect(() => {
        if (!clarity?.identify || !userProfile?.email) return;

        try {
            clarity.identify(
                userProfile.email,
                undefined,
                userProfile.fullName
            );

            clarity.setTag("visitor_type", "Candidate");
        } catch {}
    }, [userProfile]);
};